import { render, staticRenderFns } from "./dialog-follower.vue?vue&type=template&id=5d84ec94&scoped=true&"
import script from "./dialog-follower.vue?vue&type=script&lang=js&"
export * from "./dialog-follower.vue?vue&type=script&lang=js&"
import style0 from "./dialog-follower.vue?vue&type=style&index=0&id=5d84ec94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d84ec94",
  null
  
)

export default component.exports